module.exports = __webpack_public_path__ + "img/user-wallet.7ddd479e.svg";